import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { intlShape, injectIntl } from 'react-intl';

import { Combobox } from '@salesforce/design-system-react';

import './SubscriberType.scss';

class SubscriberType extends Component {
  currentSelection() {
    const type = this.props.subscriberType;
    return type ? [this.selectionFor(type)] : [];
  }

  selectionFor(subscriberType) {
    const { formatMessage } = this.props.intl;
    const i18nKey = 'components.ecs.rules.subscriber';
    return {
      id: subscriberType,
      label: formatMessage({ id: `${i18nKey}.${subscriberType}` }),
      value: subscriberType
    };
  }

  options() {
    const types = ['subscriber_key', 'subscriber_id'];
    return types.map(this.selectionFor.bind(this));
  }

  render() {
    const { formatMessage } = this.props.intl;

    return (
      <div className="subscriber-type">
        <Combobox
          classNameContainer="subscriber-type-combobox"
          labels={{
            label: formatMessage({
              id: 'components.ecs.rules.subscriber.label'
            })
          }}
          readonly
          options={this.options()}
          selection={this.currentSelection()}
          events={{
            onSelect: (evt, data) => {
              this.props.onSettingChanged(
                'subscriber_type',
                data.selection && data.selection[0] && data.selection[0].value
              );
            }
          }}
          variant="readonly"
        />
      </div>
    );
  }
}

SubscriberType.propTypes = {
  subscriberType: PropTypes.string,
  onSettingChanged: PropTypes.func.isRequired,
  intl: intlShape.isRequired
};

export default injectIntl(SubscriberType);
